import React, { memo } from 'react'
import { Box, Flex, Grid } from '@chakra-ui/core'

import { SkeletonBlock } from './common'

const TaskCardSkeleton = memo(() => (
  <Box
    bg="white"
    border="1px solid #E2E8F0"
    borderRadius="8px"
    mb="8px"
    px="12px"
    py="12px"
    boxShadow="0 1px 3px rgba(15,23,42,0.06)"
  >
    {/* title + badge — badge (py="3px" + 10px*1.25 lineHeight + border) = 20.5px drives row height */}
    <Flex align="center" style={{ gap: '6px' }}>
      <SkeletonBlock h="13px" w="52%" borderRadius="999px" />
      <SkeletonBlock h="21px" w="72px" borderRadius="999px" />
    </Flex>

    {/* meta row — fontSize="11px" lineHeight≈1.5 → ~16.5px */}
    <Flex mt="7px" align="center" style={{ gap: '8px' }}>
      <SkeletonBlock h="17px" w="90px" borderRadius="999px" />
    </Flex>

    {/* time chips — fontSize="10px" lineHeight="1.2" py="3px" + border → 20px */}
    <Flex mt="10px" style={{ gap: '6px' }}>
      <SkeletonBlock h="20px" w="108px" borderRadius="6px" />
      <SkeletonBlock h="20px" w="108px" borderRadius="6px" />
    </Flex>

    {/* progress bar — text fontSize="11px" lineHeight≈1.5 → ~16.5px, drives Flex height */}
    <Flex mt="9px" align="center" style={{ gap: '8px' }}>
      <SkeletonBlock h="6px" borderRadius="999px" />
      <SkeletonBlock h="17px" w="28px" borderRadius="999px" />
    </Flex>
  </Box>
))

export const TaskListSkeleton = () => (
  <>
    {Array.from({ length: 6 }).map((_, index) => (
      <TaskCardSkeleton key={index} />
    ))}
  </>
)

export const KpiGridSkeleton = memo(() => (
  <Grid templateColumns="repeat(4, minmax(0, 1fr))" gap={{ base: '6px', md: '8px', xl: '10px' }} mb="14px">
    {(['#334155', '#2563EB', '#7C3AED', '#0E7490'] as const).map((color) => (
      <Flex key={color} bg={`${color}14`} borderRadius="8px" p="12px" align="center" style={{ gap: '10px' }}>
        <SkeletonBlock h="38px" w="38px" borderRadius="8px" />
        <Box minW={0} flex={1}>
          <SkeletonBlock h="10px" w="70%" borderRadius="999px" mb="7px" />
          <SkeletonBlock h="22px" w="44px" borderRadius="6px" />
        </Box>
      </Flex>
    ))}
  </Grid>
))

export const ContextListSkeleton = () => (
  <>
    {Array.from({ length: 6 }).map((_, index) => (
      <Flex
        key={index}
        bg="white"
        border="1px solid #E2E8F0"
        borderRadius="8px"
        p="12px"
        mb={index === 5 ? '0' : '10px'}
        align="center"
        justify="space-between"
        boxShadow="0 1px 4px rgba(15,23,42,0.07)"
        style={{ gap: '12px' }}
      >
        <Flex align="center" minW={0} flex={1} style={{ gap: '11px' }}>
          <SkeletonBlock h="38px" w="38px" borderRadius="999px" />
          <Box flex={1} minW={0}>
            <SkeletonBlock h="13px" w="44%" mb="7px" borderRadius="3px" />
            <SkeletonBlock h="10px" w="28%" borderRadius="3px" />
          </Box>
        </Flex>
        <Flex align="center" justify="flex-end" flexShrink={0} style={{ gap: '10px' }}>
          <SkeletonBlock h="11px" w="112px" borderRadius="3px" />
          <SkeletonBlock h="16px" w="56px" borderRadius="3px" />
        </Flex>
      </Flex>
    ))}
  </>
)
